import { inputAnimationEvents } from "../components/formElementsUtil";
import { MAP_MARKER_COLOR, MAP_DARK_MARKER_COLOR, MAP_LABEL_COLOR, MAP_LABEL_FONT_SIZE, MAP_AUTH_FAILED_CLASS } from "../utilities/constants";
import {
    appendError,
    getMap,
    getStoreMarker,
    mapMarkerIcon,
    setStoresDistance
} from "../components/coverageAreaUtil";
import {
    setFilledStatus,
    handlePostalCodeInputRules,
    setDynamicHeight
} from "../utilities/globalUtilities";
import { shippingNewAddressEvents } from "./shippingNewAddress";
import SimpleBar from "simplebar";
const scrollLock = require("../utilities/scrollLock");
const regex = require("../utilities/regex");
const debounce = require("lodash/debounce");
const mqueryRespond = window.mqRespond;
import { appendToUrl } from "../search/urlUtils";
import {
    showCoverageAreaErrorModal,
    checkCoverageArea
} from "./shippingCTUtils";
import { getAddressStoreData } from "./shippingCT";
import { GTM_HOME, GTM_CG, GTM_CHANGE_ADDRESS} from "../utilities/constants";

const $cache = {
    document: $(document),
    body: $("body"),
    shippingCoverageAreaModal: $("#shipping-coverage-area-modal"),
    shippingConfirmCoverageAreaModal: $("#shipping-confirm-coverage-area-modal")
};

let storeToShow;
let customerCoordinates = {};
let selectedDeliveryPoint;
let searchCoordinates = {};

/**
 * @function
 * @description - Sets dynamically the height for the stores sections based on the remaining available viewport area
 * after the visible adjacent elements heights are substracted from the viewport height
 */
const setStoresSectionHeight = () => {
    if (mqueryRespond.status.mobile) {
        setTimeout(() => {
            setDynamicHeight(
                document.querySelector(".delivery-nearest"),
                document.querySelectorAll("#shipping-coverage-area-modal :is(.modal-header, .js-shipping-modal-description, .js-coverage-area-form, .js-separator-container, .delivery-home, .js-store-details.pwc-form-radio, .separator-container"),
                35
            );
        }, 300);
    }
};

/**
 * @function
 * @description - Retrieves postal code of customer current position
 */
const getPostalReverse = () => {
    $cache.document.on("click", ".js-postal-code-get-coordinates", () => {
        const $postalCodeInput = $cache.shippingCoverageAreaModal.find("#coverage-postal-code");

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    customerCoordinates.latitude = position.coords.latitude;
                    customerCoordinates.longitude = position.coords.longitude;

                    let google = window.google;
                    let geocoder = new google.maps.Geocoder();
                    let latlng = { lat: parseFloat(customerCoordinates.latitude), lng: parseFloat(customerCoordinates.longitude) };

                    if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
                        appendError(".js-coverage-area-error", "data-error-auth-failed");
                        return;
                    }

                    geocoder.geocode({ location: latlng }, (results, status) => {
                        if (status === "OK") {
                            if (results.length > 0) {
                                let postalDetected = false;
                                for (let i = 0; i < results.length; i++) {
                                    let result = results[i];

                                    if (result.types.indexOf("postal_code") !== -1) {
                                        let postalCode = result.address_components[0].long_name;
                                        if (postalCode && postalCode.length == 4 && regex.values.digits.test(postalCode)) {
                                            postalCode = postalCode.padEnd(8, "-000");
                                        }

                                        postalDetected = true;
                                        $postalCodeInput.val(postalCode).addClass("filled");
                                        document.querySelectorAll("#shipping-coverage-area-modal .postal-code-btn").forEach(btn => btn.classList.remove("d-none"));
                                        break;
                                    }
                                }
                                if (!postalDetected) {
                                    appendError(".js-coverage-area-error", "data-error-general");
                                }
                            } else {
                                appendError(".js-coverage-area-error", "data-error-nostores");
                            }
                        } else {
                            appendError(".js-coverage-area-error", "data-error-general");
                        }
                    });
                },
                () => appendError(".js-coverage-area-error", "data-error-allowgeo")
            );
        } else {
            appendError(".js-coverage-area-error", "data-error-apigeo");
        }
    });
};

/**
 * @function
 * @description Calculates distance to stores once google map script loaded.
 */
const googlemapInitialized = () => {
    $cache.document.on("googlemap:initialized", () => {
        if ($("#shipping-coverage-area-modal").find(".search-coordinates").length) {
            setStoresDistance($("#shipping-coverage-area-modal"));
        }
    });
};

/**
 * @function
 * @description - Asks for geolocation permission before rendering map.
 */
const showStoreDetails = () => {
    $cache.document.on("click", ".js-store-marker", e => {
        storeToShow = $(e.currentTarget);
        navigator.geolocation.getCurrentPosition(onPositionAllow, onPositionDecline);
    });
};

/**
 * @function
 * @description - Shows google map for selected store with customer position
 */
const onPositionAllow = (position) => {
    customerCoordinates.latitude = position.coords.latitude;
    customerCoordinates.longitude = position.coords.longitude;

    showStoresMap(storeToShow);
};

/**
 * @function
 * @description - Shows google map for selected store without customer position
 */
const onPositionDecline = () => {
    customerCoordinates.latitude = null;
    customerCoordinates.longitude = null;

    showStoresMap(storeToShow);
};

/**
 * @private
 * @function
 * @description - Starts the stores map
 * @param {Element} selectedStore - Selected store element
 */
const showStoresMap = selectedStore => {
    let storeMarker;
    let customerMarker;
    let google = window.google;
    let map = getMap("map-stores");
    let bounds = new google.maps.LatLngBounds();
    let storeDetailsSelector = $cache.shippingCoverageAreaModal.find(".delivery-nearest .store-details");
    let jsStoreDetailsSelector = $cache.shippingCoverageAreaModal.find(".delivery-nearest .js-store-details");
    let stores = storeDetailsSelector.length ? storeDetailsSelector : jsStoreDetailsSelector;
    const $coverageModalBody = $cache.shippingCoverageAreaModal.find(".coverage-modal-body");
    const $primaryCoverageModalTitle = $cache.shippingCoverageAreaModal.find(".primary-title");
    const $secondaryCoverageModalTitle = $cache.shippingCoverageAreaModal.find(".secondary-title");
    const $storesMapArea = $cache.shippingCoverageAreaModal.find(".stores-map-area");
    const $storeInfo = $cache.shippingCoverageAreaModal.find(".store-info");
    const $arrowBack = $cache.shippingCoverageAreaModal.find(".js-arrow-back");
    const $deliveryArea = $cache.shippingCoverageAreaModal.find(".js-delivery-area");

    $arrowBack.removeClass("d-none");
    $coverageModalBody.addClass("coverage-modal-map");
    $primaryCoverageModalTitle.addClass("d-none");
    $secondaryCoverageModalTitle.removeClass("d-none");
    selectedDeliveryPoint = selectedStore.closest("div.store-details").length ? selectedStore.closest("div.store-details") : selectedStore.closest("div.js-store-details");

    $deliveryArea.addClass("d-none");
    let storeDetails = selectedStore.parent().data("storedetails");

    stores.each(function () {
        let storeWrapper = $(this);

        if (storeWrapper.data("delivery-latitude") != null && storeWrapper.data("delivery-longitude") != null) {
            if (storeWrapper.data("sid") != storeDetails.ID) {
                storeMarker = getStoreMarker(storeWrapper, map);
                bounds.extend(storeMarker.position);
            }
        }
    });

    // prepare marker for selected store
    let storePosition = {lat: Number(storeDetails.latitude), lng: Number(storeDetails.longitude)};
    let storeIndex = parseInt(selectedStore.parent().data("index"), 10).toString();

    let storeLocation = new google.maps.Marker({
        icon: mapMarkerIcon(MAP_DARK_MARKER_COLOR),
        label: {
            text: storeIndex,
            color: MAP_LABEL_COLOR,
            fontSize: MAP_LABEL_FONT_SIZE
        },
        position: storePosition,
        map: map,
        optimized: false,
        zIndex: 2
    });

    bounds.extend(storeLocation.position);

    // prepare customer current location
    if (customerCoordinates.latitude && customerCoordinates.longitude) {
        customerMarker = getCustomerMarker(map);
        bounds.extend(customerMarker.position);
    }

    map.fitBounds(bounds);

    $storesMapArea.removeClass("d-none");
    $storeInfo.empty().html(selectedStore.parent().find(".store-detailed-info").html());
    $storeInfo.removeClass("d-none");
    $coverageModalBody.closest(".modal-dialog").addClass("coverage-area-modal");
};

/**
 * @function
 * @description - Handles confirmation of selected delivery point.
 * Receives coverage area response and sets store context.
 */
const confirmAreaSelect = () => {
    const $this = selectedDeliveryPoint;
    const selectedPostal = $this.data("postal");
    const selectedDeliveryLocation = $this.data("delivery-location");
    const selectedDeliveryLatitude = $this.data("delivery-latitude");
    const selectedDeliveryLongitude = $this.data("delivery-longitude");
    const selectedID = $this.data("sid");
    const selectedAddressId = $this.data("address-id");
    const storeGetCoverageURL = $(".js-store-getcoverage-url").attr("data-url");
    const storeSetContextURL = $(".js-store-setcontext-url").attr("data-url");
    let params = { postalCode: selectedPostal };

    // call Stores-GetCoverageArea
    // receive feedback
    $.ajax({
        url: storeGetCoverageURL,
        type: "GET",
        data: params,
        success: response => {
            if (!response.error) {
                // call SetStoreContext (needs storeId and storeInfo)
                params = {
                    storeId: response.data.storeId,
                    physicalStoreId: response.data.physicalStoreId,
                    areaID: response.data.areaID,
                    storeID: response.data.storeID,
                    storeInfo: selectedDeliveryLocation || "",
                    storePostalCode: selectedPostal,
                    latitude: selectedDeliveryLatitude || "",
                    longitude: selectedDeliveryLongitude || "",
                    searchLatitude: selectedDeliveryLatitude || "",
                    searchLongitude: selectedDeliveryLongitude || "",
                    ID: selectedID,
                    selectedAddressId: selectedAddressId
                };

                $.post(storeSetContextURL, params, responseData => {
                    if (!responseData.error) {
                        //GTM logic start
                        document.dispatchEvent(new CustomEvent("dataLayer.deliveryAreaEvents", {
                            detail: {
                                "status": response.data.customerStatus,
                                "action": GTM_CHANGE_ADDRESS,
                                "type": selectedID ? GTM_CG : GTM_HOME
                            }
                        }));
                        //GTM logic end

                        $(".store-context-info").first().html("true");

                        $.spinner().stop();
                        $cache.shippingConfirmCoverageAreaModal.modal("hide");
                        $cache.shippingCoverageAreaModal.modal("hide");
                        location.reload();

                        // Redirect to Cart page
                        let cartURL = $(".js-cart-url").attr("data-url");
                        cartURL = appendToUrl(cartURL, {"isCheckoutRedirected" : true});
                        window.location.href = cartURL;
                    } else {
                        $.spinner().stop();
                        appendError(".js-coverage-area-error", responseData.message);
                        $cache.shippingConfirmCoverageAreaModal.modal("hide");
                        showCoverageAreaErrorModal();
                    }
                });
            } else {
                $.spinner().stop();
                appendError(".js-coverage-area-error", response.message);
                $cache.shippingConfirmCoverageAreaModal.modal("hide");
                showCoverageAreaErrorModal();
            }
        }
    });
};

/**
 * @function
 * @description Handles click on the Cancel button on the confirmation modal.
 */
const declineAreaSelect = () => {
    $cache.document.on("hidden.bs.modal", "#shipping-confirm-coverage-area-modal", () => {
        $cache.shippingConfirmCoverageAreaModal.modal("hide");

        //uncheck a radio button if a delivery point wasn't confirmed
        let $checkmarks = $(".js-delivery-area .checkmark");
        $checkmarks.each(function () {
            let $clickedCheckmark = $(this).parent().find("input")[0];

            if ($clickedCheckmark.hasAttribute("checked") === true && $clickedCheckmark.checked === false) {
                $clickedCheckmark.checked = true;
            } else if ($clickedCheckmark.hasAttribute("checked") === false && $clickedCheckmark.checked === true) {
                $clickedCheckmark.checked = false;
            }
        });
    });

    $cache.document.on("shown.bs.modal", "#shipping-confirm-coverage-area-modal", debounce(() => {
        $cache.body.addClass("modal-open");
        scrollLock.enable();
    }, 1));
};

/**
 * @private
 * @function
 * @description - Returns marker of customer current position
 * @param {Object} map - Map object
 */
const getCustomerMarker = map => {
    let google = window.google;
    let customerPosition = {lat: Number(customerCoordinates.latitude), lng: Number(customerCoordinates.longitude)};
    let customerLocation = new google.maps.Marker({
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            strokeColor: MAP_MARKER_COLOR,
            strokeWeight: 1,
            scale: 5
        },
        clickable: false,
        position: customerPosition,
        map: map,
        optimized: false
    });

    return customerLocation;
};

/**
 * @function
 * @description Copies the zip code that was used to seach for stores
 * to the zip input field that is present in the new address modal
 * @param {Element} selector - Parent element to find child zip elements
 */
const copyZipCodeToNewAddress = selector => {
    const coveragePostalCode = document.getElementById("coverage-postal-code");
    const zipCodeInput = selector.querySelector(".ct-address-form--zipcode-input");
    const locationInput = selector.querySelector("#city");
    const isPostalCode = regex.values.coverageAreaPostalCode.test(coveragePostalCode.value) ? true : false;

    if (coveragePostalCode?.value?.length) {
        if (locationInput != null && !isPostalCode) {
            locationInput.value = coveragePostalCode.value;
            locationInput.focus();
            return;
        }

        if (zipCodeInput != null && isPostalCode) {
            zipCodeInput.value = coveragePostalCode.value;
            zipCodeInput.focus();
            return;
        }
    }
};

/**
 * @function
 * @description Handles click on a radio button in front of delivery address.
 * Saves selected element in order to use in confirmAreaSelect() function.
 */
const setStoreContext = async () => {
    $cache.shippingCoverageAreaModal.on("click", ".js-store-details .pwc-form-check-input", async e => {
        e.stopPropagation();
        const newAddressContainer = document.querySelector(".js-new-address-container");

        const $this = $(e.currentTarget);
        const $modalBody = $this.closest(".coverage-modal-body");
        const targetParams = getAddressStoreData($modalBody);

        let callbackResult;
        checkCoverageArea(targetParams, result => {
            callbackResult = result;
        });

        if (callbackResult.error || !callbackResult.data.storeId) {
            showCoverageAreaErrorModal();
            return;
        }

        targetParams.customerStatus = callbackResult.data.customerStatus;

        selectedDeliveryPoint = $this.closest(".js-store-details");
        // show New Address form or Confirm coverage area modal
        if ($this.hasClass("js-new-address-input")) {
            const url = selectedDeliveryPoint.data("url");

            if (url && newAddressContainer.getElementsByTagName("form").length == 0) {
                $.ajax({
                    url: url,
                    method: "GET",
                    success: data => {
                        if (data) {
                            newAddressContainer.innerHTML = data;

                            // Remove New Address form on tablet/desktop from modal
                            if (document.querySelector("#shipping-new-address-modal .address-form")) {
                                const newAddressForm = document.querySelector("#shipping-new-address-modal .address-form");
                                newAddressForm.parentNode.removeChild(newAddressForm);
                            }

                            // reinit New Address form events
                            inputAnimationEvents();
                            $cache.document.trigger("initFormValidation");
                            shippingNewAddressEvents("#shipping-coverage-area-modal");
                            copyZipCodeToNewAddress(newAddressContainer);
                            setFilledStatus();
                            handlePostalCodeInputRules();
                            $.applyDataMask($("#shipping-coverage-area-modal").find("[data-mask]"));
                        }
                    }
                });
            } else {
                copyZipCodeToNewAddress(newAddressContainer);
                $.applyDataMask($("#shipping-coverage-area-modal").find("[data-mask]"));
            }


            const $newAddressTitle = $cache.shippingCoverageAreaModal.find(".js-new-address-title");
            const $modalDescription = $cache.shippingCoverageAreaModal.find(".js-shipping-modal-description");
            const $coverageAreaForm = $cache.shippingCoverageAreaModal.find(".js-coverage-area-form");
            const $separatorContainer = $cache.shippingCoverageAreaModal.find(".js-separator-container");
            const $primaryCoverageModalTitle = $cache.shippingCoverageAreaModal.find(".primary-title");
            const $arrowBack = $cache.shippingCoverageAreaModal.find(".js-arrow-back");
            const $deliveryArea = $cache.shippingCoverageAreaModal.find(".js-delivery-area");
            const $newAddressWrapper = $cache.shippingCoverageAreaModal.find(".js-new-address-container");

            $newAddressTitle.removeClass("d-none");
            $arrowBack.removeClass("d-none");
            $deliveryArea.addClass("d-none");
            $newAddressWrapper.removeClass("d-none");
            $modalDescription.addClass("d-none");
            $coverageAreaForm.addClass("d-none");
            $separatorContainer.addClass("d-none");
            $primaryCoverageModalTitle.addClass("d-none");
        } else {
            const $shippingCoverageAreaModalBody = $cache.shippingCoverageAreaModal.find(".coverage-modal-body");

            if ($shippingCoverageAreaModalBody.hasClass("coverage-modal-map")) {
                storeToShow = selectedDeliveryPoint.find(".js-store-marker");
                navigator.geolocation.getCurrentPosition(onPositionAllow, onPositionDecline);
            } else {
                coverageAreaCorfirm($this);
            }
        }
    });
};

/**
 * @private
 * @function
 * 
 * @description Closes the coverage area modal and shows the confirmation modal.
 * 
 * @param {jQuery} $this - jQuery object referring to the current element
 */
const coverageAreaCorfirm = ($this) => {
    $this.closest(".shipping-coverage-area-modal--body").addClass("js-closed-for-confirmation");
    $cache.shippingConfirmCoverageAreaModal.modal("show");
    $cache.shippingCoverageAreaModal.modal("hide");
};

/**
 * @function
 * @description Handles click on a radio button in front of delivery address.
 */
const setStoreContextOnMap = () => {
    $cache.shippingCoverageAreaModal.on("click", ".coverage-area-select", () => {
        $cache.shippingCoverageAreaModal.modal("hide");
    });
};

/**
 * @function
 * @description Handles click on back arrow on modal.
 */
const modalNavigation = () => {
    $cache.document.on("click", ".js-arrow-back", () => {
        const $newAddressTitle = $cache.shippingCoverageAreaModal.find(".js-new-address-title");
        const $coverageModalBody = $cache.shippingCoverageAreaModal.find(".coverage-modal-body");
        const $primaryCoverageModalTitle = $cache.shippingCoverageAreaModal.find(".primary-title");
        const $secondaryCoverageModalTitle = $cache.shippingCoverageAreaModal.find(".secondary-title");
        const $storesMapArea = $cache.shippingCoverageAreaModal.find(".stores-map-area");
        const $storeInfo = $cache.shippingCoverageAreaModal.find(".store-info");
        const $coverageAreaForm = $cache.shippingCoverageAreaModal.find(".js-coverage-area-form");
        const $separatorContainer = $cache.shippingCoverageAreaModal.find(".js-separator-container");
        const $arrowBack = $cache.shippingCoverageAreaModal.find(".js-arrow-back");
        const $deliveryArea = $cache.shippingCoverageAreaModal.find(".js-delivery-area");
        const $newAddressWrapper = $cache.shippingCoverageAreaModal.find(".js-new-address-container");

        $newAddressTitle.addClass("d-none");
        $arrowBack.addClass("d-none");
        $deliveryArea.removeClass("d-none");
        $newAddressWrapper.addClass("d-none");
        $primaryCoverageModalTitle.removeClass("d-none");
        $secondaryCoverageModalTitle.addClass("d-none");
        $storesMapArea.addClass("d-none");
        $storeInfo.addClass("d-none");
        $coverageAreaForm.removeClass("d-none");
        $separatorContainer.removeClass("d-none");
        $coverageModalBody.removeClass("coverage-modal-map").closest(".modal-dialog").removeClass("coverage-area-modal");
        $coverageModalBody.parent().removeClass("triggered-on-load");
        $(".js-new-address").find(".pwc-form-check-input").prop("checked", false);
    });
};

/**
 * @private
 * @function
 * @description - Loads next chunk of stores
 */
const storesScrollInit = () => {
    const $deliveryNearest = $cache.shippingCoverageAreaModal.find(".delivery-nearest");

    if ($deliveryNearest.length) {
        const simpleBar = new SimpleBar(document.querySelector("#shipping-coverage-area-modal .delivery-nearest"));
        const simpleBarScrollElement = simpleBar.getScrollElement();

        if (!simpleBarScrollElement) { return; }

        simpleBar.getScrollElement().addEventListener("scroll", debounce(function () {
            const $this = $(this);

            if ($this.scrollTop() + $this.innerHeight() >= $this[0].scrollHeight && $this.find(".coverage-area-no-stores-chunk").length === 0) {
                const storesPerLoadNext = Math.floor($deliveryNearest.attr("data-stores-per-load-next"));

                const params = {
                    latitude: searchCoordinates.latitude,
                    longitude: searchCoordinates.longitude,
                    storesPerLoadNext: storesPerLoadNext
                };

                $.ajax({
                    url: $deliveryNearest.data("url"),
                    type: "GET",
                    data: params,
                    success: response => {
                        const storesPerLoadFuture = storesPerLoadNext + Math.floor($deliveryNearest.attr("data-stores-per-load"));

                        $deliveryNearest.find(".simplebar-content").append(response);
                        $deliveryNearest.attr("data-stores-per-load-next", storesPerLoadFuture);
                        if ($cache.shippingCoverageAreaModal?.find(".search-coordinates").length) {
                            setStoresDistance($cache.shippingCoverageAreaModal);
                        }
                    }
                });
            }
        }, 100));
    }
};

/**
 * @function
 * @description - Tries to find a nearby store using the provided postal code
 */
const findStoreByPostalCode = () => {
    $cache.shippingCoverageAreaModal.on("submit", ".coverage-area-form", e => {
        e.preventDefault();

        $cache.shippingCoverageAreaModal.find("#coverage-postal-code").trigger("blur");

        let google = window.google;
        let $this = $(e.currentTarget);
        let deliveryLocation = $this.find(".postal-code").val();
        const clickAndGoStoreId = $this.attr("data-click-and-go-store-id");

        if (!deliveryLocation || (regex.values.digits.test(deliveryLocation) && !regex.values.coverageAreaPostalCode.test(deliveryLocation))) {
            appendError(".js-coverage-area-error", "data-error-postalcode");
            return;
        }

        if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
            appendError(".js-coverage-area-error", "data-error-auth-failed");
            return;
        }

        const url = $(e.target).attr("action");
        $cache.shippingCoverageAreaModal.spinner().start();
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({"address": deliveryLocation, "componentRestrictions": {"country": "PT"}}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0].geometry.location.lat() && results[0].geometry.location.lng()) {
                    let deliveryPostalCode = "";
                    let result = results[0];
                    for (let i = 0; i < result.address_components.length; i++) {
                        let addressComponent = result.address_components[i];

                        if (addressComponent.types.indexOf("postal_code") !== -1 && addressComponent.long_name) {
                            deliveryPostalCode = addressComponent.long_name;
                            break;
                        }
                    }

                    searchCoordinates.latitude = results[0].geometry.location.lat();
                    searchCoordinates.longitude = results[0].geometry.location.lng();

                    const params = {
                        deliveryLocation: deliveryLocation,
                        deliveryPostalCode: deliveryPostalCode,
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                        searchLatitude: results[0].geometry.location.lat(),
                        searchLongitude: results[0].geometry.location.lng()
                    };

                    const currentShipmentId = $this.data("shipment-id");
                    const $activeStepContainer = $(`.step-type--address[data-shipment-id="${currentShipmentId}"]`);
                    const currentShipmentSelectedAddressId = $this.data("selected-delivery");
                    const currentShipmentDeliveryLocation = $this.data("postal-code") || $this.data("postal");
                    const isPrimaryShipment = $this.data("is-primary");
                    const showStores = $activeStepContainer.data("show-stores");
                    const showAddresses = $activeStepContainer.data("show-addresses");
                    const wasTriggeredOnLoad = $this.closest(".shipping-coverage-area-modal--body").hasClass("triggered-on-load");

                    if (!currentShipmentDeliveryLocation) { return; }

                    const urlParams = {
                        "clickAndGoStoreId": regex.values.coverageAreaPostalCode.test(deliveryLocation) ? clickAndGoStoreId : undefined,
                        "showStores": showStores,
                        "currentShipmentId": currentShipmentId,
                        "shipmentDeliveryLocation": currentShipmentSelectedAddressId,
                        "postalCode": currentShipmentDeliveryLocation,
                        "isPrimaryShipment": isPrimaryShipment,
                        "showAddresses": showAddresses
                    };

                    const completedUrl = appendToUrl(url, urlParams);

                    $.ajax({
                        url: completedUrl,
                        type: "GET",
                        data: params,
                        success: response => {
                            const $deliveryArea = $cache.shippingCoverageAreaModal.find(".js-delivery-area");
                            const $coverageSubtitleWrapper = $cache.shippingCoverageAreaModal.find(".coverage-subtitle-wrapper");
                            const $separatorArea = $cache.shippingCoverageAreaModal.find(".separator-area");

                            $deliveryArea.html(response).removeClass("d-none");

                            setStoreContextOnMap();
                            storesScrollInit();

                            //calculate and add distances
                            setStoresDistance($cache.shippingCoverageAreaModal);

                            // if another location is inserted while the store map is displayed, update the store map with the new response
                            if ($this.closest(".coverage-modal-body").hasClass("coverage-modal-map")) {
                                const $newDeliveryPoints = $cache.shippingCoverageAreaModal.find(".delivery-nearest");

                                if ($newDeliveryPoints.children().length) {
                                    const $firstStore = $newDeliveryPoints.find(".js-store-details").first().find(".js-store-marker");
                                    $firstStore.trigger("click");
                                }
                            } else {
                                $coverageSubtitleWrapper.addClass("d-none");
                                $separatorArea.addClass("no-text");
                                $deliveryArea.removeClass("d-none");
                            }

                            if (currentShipmentSelectedAddressId == "shipment-1-new-address" && wasTriggeredOnLoad) {
                                $deliveryArea.find(".js-new-address-input:checked").trigger("click");
                            }
                        },
                        complete: () => {
                            setStoresSectionHeight();
                            $cache.shippingCoverageAreaModal.spinner().stop();
                        }
                    });
                }
            } else {
                appendError(".js-coverage-area-error", status == google.maps.GeocoderStatus.ZERO_RESULTS ? "data-error-nostores" : "data-error-general");
                $cache.shippingCoverageAreaModal.spinner().stop();
            }
        });
    });
};

/**
 * Init Shipping coverage area
 */
const initCoverageArea = () => {
    getPostalReverse();
    googlemapInitialized();
    showStoreDetails();
    setStoreContext();
    setStoreContextOnMap();
    declineAreaSelect();
    modalNavigation();
    findStoreByPostalCode();
};

export { initCoverageArea, confirmAreaSelect };
